<app-moment icon="assignment" title="Discharge" colour="#9ee7cc" [momentData]='momentData'>
  <div class="discharge" fxLayoutAlign="left">
    Discharging Therapist: {{momentData.therapistName}}
  </div>
</app-moment>
